import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import {
  InterfaceRequirementListPageContext,
  InterfaceRequirementListPageInitialState,
} from ".";

export const InterfaceRequirementListPageStateProvider = ({
  children,
}: any) => {
  const [pageState, setPageState] = useState(
    InterfaceRequirementListPageInitialState,
  );
  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <InterfaceRequirementListPageContext.Provider value={context}>
      {children}
    </InterfaceRequirementListPageContext.Provider>
  );
};
